export default __webpack_public_path__ + "static/media/Broadcasting.511a8bed.png";